module.exports = __webpack_public_path__ + "static/media/9C.cf6317bc.svg";